module.exports = __webpack_public_path__ + "static/media/021.0e766984.jpg";